import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import { AlertService } from '../../services/alert.service';
import { FirmwareService } from '../../services/firmware.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'firmware-v2-myscale',
    templateUrl: './firmware-v2-myscale.component.html',
    styleUrls: ['./firmware-v2-myscale.component.scss']
})
export class FirmwareV2MyScaleComponent implements OnInit, OnDestroy, OnChanges {

    @Input()
    product: any;

    newFirmwareVisible!: boolean;

    newFirmwareFormGroup!: FormGroup;

    newFirmwareSelectedFile!: File | null;

    firmwares!: any[];

    selectedFirmwareToEdit: any;

    editFirmwareFormGroup: any;

    deleteFirmwareVisibles: any = {};

    firmwareCompare = (a: any, b: any) => {
        if (a.internalModel != b.internalModel) {
            return a.internalModel.localeCompare(b.internalModel);
        } else if (a.hardwareModel != b.hardwareModel) {
            return a.hardwareModel.localeCompare(b.hardwareModel);
        } else {
            return -a.version + b.version;
        }
    };

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private firmwareService: FirmwareService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.newFirmwareFormGroup = this.formBuilder.group({
            newFirmwareInternalModelInput: [null, Validators.required],
            newFirmwareHardwareModelInput: [null, Validators.required],
            newFirmwareVersionInput: [null, Validators.required],
            newFirmwareVersionMkzInput: [null, Validators.required],
            newFirmwareCrcInput: [null, Validators.required],
            newFirmwareFileInput: [null, Validators.required]
        });
        this.newFirmwareSelectedFile = null;
    }

    ngOnDestroy() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.refreshFirmwares();
    }

    displayNewFirmwareFormGroup() {
        if (this.newFirmwareFormGroup) {
            this.newFirmwareFormGroup.reset();
        }
        this.newFirmwareSelectedFile = null;
        this.newFirmwareVisible = true;
        this.cancelSelectedFirmwareToEdit();
    }

    hideNewFirmwareFormGroup() {
        if (this.newFirmwareFormGroup) {
            this.newFirmwareFormGroup.reset();
        }
        this.newFirmwareSelectedFile = null;
        this.newFirmwareVisible = false;
    }

    refreshFirmwares() {
        this.deleteFirmwareVisibles = {};
        this.hideNewFirmwareFormGroup();
        this.cancelSelectedFirmwareToEdit();
        this.getFirmwares();
    }

    getFirmwares() {
        this.progressIndicatorService.progress = true;
        this.firmwareService.getV2MyScaleFirmwares().subscribe({
            next: (value: any) => {
                console.log('FirmwareV2MyScaleComponent.getFirmwares.firmwareService.getV2MyScaleFirmwares.value', value);
                this.progressIndicatorService.progress = false;
                this.firmwares = value.firmwares;
                this.firmwares.sort(this.firmwareCompare);
            },
            error: (error: any) => {
                console.log('FirmwareV2MyScaleComponent.getFirmwares.firmwareService.getV2MyScaleFirmwares.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    newFirmwareFileInputChange(event: any) {
        let file: File = event.target.files[0];
        this.newFirmwareSelectedFile = file;
    }

    uploadNewFirmware() {

        let formGroup: FormGroup = this.newFirmwareFormGroup;
        let internalModel: string = formGroup.value.newFirmwareInternalModelInput;
        let hardwareModel: string = formGroup.value.newFirmwareHardwareModelInput;
        let version: number = formGroup.value.newFirmwareVersionInput;
        let mkzVersion: string = formGroup.value.newFirmwareVersionMkzInput;
        let crc: string = formGroup.value.newFirmwareCrcInput;
        let file: File | null = this.newFirmwareSelectedFile;
        if (file == null) return;

        this.progressIndicatorService.progress = true;
        this.firmwareService.uploadV2MyScaleFirmware(internalModel, hardwareModel, version, mkzVersion, crc, file).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2MyScaleComponent.uploadNewFirmware.firmwareService.uploadV2MyScaleFirmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2MyScaleComponent.uploadNewFirmware.firmwareService.uploadV2MyScaleFirmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    toValidateFirmware(firmwareId: string) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.toValidateV2MyScaleFirmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2MyScaleComponent.toValidateFirmware.firmwareService.toValidateV2MyScaleFirmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2MyScaleComponent.toValidateFirmware.firmwareService.toValidateV2MyScaleFirmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    validateFirmware(firmwareId: string) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.validateV2MyScaleFirmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2MyScaleComponent.validateFirmware.firmwareService.validateV2MyScaleFirmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2MyScaleComponent.validateFirmware.firmwareService.validateV2MyScaleFirmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    publishFirmware(firmwareId: string) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.publishV2MyScaleFirmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2MyScaleComponent.publishFirmware.firmwareService.publishV2MyScaleFirmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2MyScaleComponent.publishFirmware.firmwareService.publishV2MyScaleFirmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    displaySelectedFirmwareToEdit(firmwareId: string) {
        let firmware: any = this.firmwares.find((f: any) => f.id == firmwareId);
        if (firmware) {
            this.selectedFirmwareToEdit = firmware;
            this.editFirmwareFormGroup = this.formBuilder.group({
                editFirmwareInternalModelInput: [{ value: firmware.internalModel, disabled: true }, /*Validators.required*/],
                editFirmwareHardwareModelInput: [{ value: firmware.hardwareModel, disabled: true }, /*Validators.required*/],
                editFirmwareVersionInput: [{ value: firmware.version, disabled: false }, Validators.required],
                editFirmwareVersionMkzInput: [{ value: firmware.mkzVersion, disabled: false }, Validators.required],
                editFirmwareCrcInput: [{ value: firmware.crc, disabled: true }, /*Validators.required*/],
                editFirmwareFileInput: [{ value: firmware.filename, disabled: true }, /*Validators.required*/]
            });
        } else {
            this.selectedFirmwareToEdit = null;
            this.editFirmwareFormGroup = null;
        }
        this.hideNewFirmwareFormGroup();
    }

    updateSelectedFirmwareToEdit() {

        let firmwareId: string = this.selectedFirmwareToEdit.id;

        let formGroup: FormGroup = this.editFirmwareFormGroup;
        let version: number = formGroup.value.editFirmwareVersionInput;
        let mkzVersion: string = formGroup.value.editFirmwareVersionMkzInput;

        this.progressIndicatorService.progress = true;
        this.firmwareService.updateV2MyScaleFirmwareVersion(firmwareId, version, mkzVersion).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2MyScaleComponent.updateSelectedFirmwareToEdit.firmwareService.updateV2MyScaleFirmwareVersion.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.selectedFirmwareToEdit = null;
                this.editFirmwareFormGroup = null;
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2MyScaleComponent.updateSelectedFirmwareToEdit.firmwareService.updateV2MyScaleFirmwareVersion.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    cancelSelectedFirmwareToEdit() {
        this.selectedFirmwareToEdit = null;
        this.editFirmwareFormGroup = null;
    }

    displayDeleteFirmware(firmwareId: string) {
        this.deleteFirmwareVisibles[firmwareId] = true;
        setTimeout(() => this.deleteFirmwareVisibles[firmwareId] = false, 3000);
    }

    deleteFirmware(firmwareId: string) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.deleteV2MyScaleFirmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV2MyScaleComponent.deleteFirmware.firmwareService.deleteV2MyScaleFirmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV2MyScaleComponent.deleteFirmware.firmwareService.deleteV2MyScaleFirmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
